import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import FileUpload from "react-material-file-upload";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import bgimage from '../../../../images/default_staff.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';




const OrderPostpond = ({ show, onClose , order }) => {

    const [isFocused] = useState(false);
    const imageInputRef = useRef(null);
    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [postponeDays, setPostponeDays] = useState([]);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();

    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    const datePickerRef = useRef();

    const handleClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };

    const handleCheckboxChange = () => {
        checkIsChecked(!Checked);
    };
    const [Checked, checkIsChecked] = useState(true);

    const [selectedDate, setSelectedDate] = useState(
        {
            orderDate: new DateObject("2025-09-02"),
        }
    );

    const fetchCateringType = async () => {
        try {
                const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                    const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.catering_type
                    }));
                    setCateringType(formatted);
                    console.log(formatted);
                }
            } catch (error) {
                console.error('Failed to fetch Catering Type:', error);
                setCateringType([]);
            }
    };

    const getCateringTypeLabel = (sno) => {
        if (!Array.isArray(cateringType)) return '';
        const found = cateringType.find(ct => ct.value === String(sno));
        return found?.label || '';
    };

    const fetchitemSchedule = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
                
                const list = response.data?.data;
        
                if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
                } else {
                setMealsPeriod([]); // fallback to empty array
                }
            } catch (error) {
                console.error('Failed to fetch Meals period:', error);
                setMealsPeriod([]); // fallback to empty array, not object
            }
    };

    const getMealsPeriodLabel = (sno) => {
        if (!Array.isArray(mealsPeriod)) return '';
        const found = mealsPeriod.find(mp => mp.value === String(sno));
        return found?.label || '';
    };

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (response.data && Array.isArray(response.data)) {
             const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                }));
                setFunctionType(formatted);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setFunctionType([]);
        }
    };

    const getFunctionTypeLabel = (sno) => {
        if (!Array.isArray(functionType)) return '';
        const found = functionType.find(ft => ft.value === String(sno));
        return found?.label || '';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const updatePostpone = async (order_id) => {
    if (!selectedDate.orderDate) {
        toast.error("Please select a postpone date.");
        return;
    }
    console.log('ordeer_id' , order_id);
    const reason = document.querySelector('textarea[name="comment"]').value.trim();
    if (!reason) {
        toast.error("Please enter a reason for postponement.");
        return;
    }

    try {
        const payload = {
            order_postpone_date: selectedDate.orderDate.format("YYYY-MM-DD"), // adjust based on backend format
            order_postpone_reason: reason
        };

        const response = await axios.put(`${BaseUrl}/manage_corporate_order/update_order_status/${order_id}/3/null`, payload);

        if (response.status === 200) {
            toast.success("Order postponed successfully!");
            onClose();
            navigate('/manage-corporate-order');
        } else {
            toast.error("Failed to postpone the order.");
        }
    } catch (error) {
        console.error("Error postponing order:", error);
        toast.error("An error occurred while postponing the order.");
    }
    };

  const getSettings = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setPostponeDays(parseFloat(response.data.data.max_pospone_days));
                } else {
                    console.log("Unexpected API response structure:", response);
                    
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
            });
    }



        useEffect(() => {
                fetchFunctionType();
                fetchCateringType();
                fetchitemSchedule();
                getSettings();
        }, []);


    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title  text-white">Order Postpone</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-4">
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Id</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.catering_id}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Name</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_name}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Mobile No</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_number}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Catering Type</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getCateringTypeLabel(order.catering_type)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Function Type</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getFunctionTypeLabel(order.function_type)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Total Cost</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>₹ {order.total}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Meals Period</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getMealsPeriodLabel(order.meals_period)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Head Count</label>
                            <div className='d-block'>
                                <label className='text-white bg-primary px-2 rounded font-w600 fs-6 py-1'>{order.head_count}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Date</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{formatDate(order.order_date)}</label>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <div className="row mb-2">
                    {(() => {
                        const postponeDays = 7; // define here or get from props/state/config

                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const orderDate = new Date(order.order_date);
                        orderDate.setHours(0, 0, 0, 0);

                        const diffTime = orderDate.getTime() - today.getTime();
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                        console.log('diffDays:', diffDays, 'postponeDays:', postponeDays);

                        if (diffDays >= postponeDays) {
                        return (
                            <>
                            <div className="col-12">
                                <label className="text-success fs-6 font-w600 mb-3">
                                You can postpone this order. (Scheduled in {diffDays} day{diffDays > 1 ? 's' : ''})
                                </label>
                            </div>

                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">
                                Order Postpone Date<span className="required">*</span>
                                </label>
                                <div className="datepicker-wrapper d-flex">
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className="fa-solid fa-calendar-days fs-4"></i>
                                </div>
                               <DatePicker
                                    value={selectedDate.orderDate}
                                    onChange={(date) => setSelectedDate(prev => ({ ...prev, orderDate: date }))}
                                    format="DD MMM YYYY"
                                    placeholder="Select Date"
                                    minDate={new DateObject().add(1, "day")}  // disables today and before
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 mb-2">
                                <label className="text-black font-w500 fs-7">
                                Reason <span className="required">*</span>
                                </label>
                                <textarea
                                rows={1}
                                className="form-control"
                                name="comment"
                                placeholder="Enter Postpone Reason"
                                defaultValue={""}
                                />
                            </div>

                            <div className="col-12 d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                                <Link
                                type="submit"
                                className="btn btn-sm btn-primary"
                                onClick={() => updatePostpone(order.id)}
                                >
                                Order Postpone <i className="fas fa-angle-double-right ms-2"></i>
                                </Link>
                            </div>
                            </>
                        );
                        } else {
                        return (
                            <div className="col-12">
                            <label className="text-danger fs-4 font-w600 mb-1">
                                Unable to postpone: Orders must be changed at least {postponeDays} days in advance. (Only {diffDays} day{diffDays !== 1 ? 's' : ''} left)
                            </label>
                            </div>
                        );
                        }
                    })()}
                    </div>

                </div>
            </div>
        </Modal >
    );
};

export default OrderPostpond;
